module.exports = __webpack_public_path__ + "static/media/prod_45000_medium.f0d8fa8c.jpg";